import { gql } from '@apollo/client';
import TICKET_COMMENTS_FRAGMENT from '../fragments/ticketCommentsFragment';

const TICKET_COMMENTS_QUERY = gql`
  query ticketComments($filter: TicketCommentFilterInput, $limit: Int) {
    ticketComments(filter: $filter, limit: $limit) {
      ...TicketCommentsFragment
    }
  }

  ${TICKET_COMMENTS_FRAGMENT}
`;

export default TICKET_COMMENTS_QUERY;
